import { InputType } from '@/types';

import type { IInput } from '@/types';

const buildParamsFromInputs = (
  inputs: IInput[] | null
): Record<string, unknown> => {
  if (!inputs) return {};

  return inputs.reduce<Record<string, unknown>>((acc, input) => {
    switch (input.type) {
      case InputType.TEXT:
        return { ...acc, [input.id]: { value: input.value } };
      case InputType.IMAGE:
      case InputType.VIDEO:
        return {
          ...acc,
          [input.id]: { url: input.src },
        };
      default:
        return acc;
    }
  }, {});
};

export { buildParamsFromInputs };
